import {createProperty} from './utils/createProperty'

/**
 * The annotation builder for a component property with type 'number'.
 */
export const number = createProperty('number').typed('number')
